"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTE_PATHS = exports.PAGE_PERMISSIONS = exports.AUTH_METHODS = void 0;
const ROUTE_PATHS = exports.ROUTE_PATHS = {
  AGENT_DYNAMIC_SCHEDULING: '/agentDynamicScheduling',
  AGENT_EXPLORER: '/agentExplorer',
  ANALYTICS_MAIL_SERVER: '/admin/analyticsMailServer',
  ANALYTICS_SUBSTITUTION: '/admin/analyticsSubstitution',
  ANALYTICS: '/analytics',
  TRANSCRIPTION_SEARCH: '/analytics/transcriptionSearch',
  ANALYTICS_DASHBOARD: '/analytics/dashboard',
  APIDOCUMENTATION: '/apiDocumentation',
  APPLICATION_MANAGEMENT: '/admin',
  BULK_CONTACT_EXPORT_MONITORING: '/admin/bulkContactExportMonitoring',
  CONTACT_QUEUE: '/contactQueue',
  PERFORMANCE_COACHING: '/performanceCoaching',
  PERFORMANCE_MANAGEMENT: '/performance-management/my-calabrio',
  AGENT_PERFORMANCE: '/performanceCoaching/AgentPerformance',
  TEAM_PERFORMANCE: '/performanceCoaching/TeamPerformance',
  ORGANIZATION_PERFORMANCE: '/performanceCoaching/OrganizationPerformance',
  METRIC_ADMINISTRATION: '/performanceCoaching/MetricAdministration',
  DASHBOARD: '/dashboard',
  DATA_EXPLORER: '/dataExplorer',
  AR_ASSET_BROWSER: '/dataExplorer/reports',
  AR_DATA_LIBRARY: '/dataExplorer/dataLibrary',
  CDM_SETTINGS: '/dataExplorer/settings',
  DEVICE_ASSOCIATIONS: '/admin/deviceAssociations',
  EVALUATION_FORM_MANAGER: '/admin/evaluationFormManager',
  INCLUSION_EXCLUSION: '/admin/inclusionExclusion',
  MESSAGING: '/messaging',
  OUTGOING_MAIL_SERVER: '/admin/outgoingMailServer',
  QM_GLOBAL_SETTINGS: '/admin/qmGlobalSettings',
  RECORDING_CONTROLS: '/recordingControls',
  RECORDINGS: '/recordings',
  REPORTS: '/reports',
  INSIGHTS: '/insights',
  BOT_ANALYTICS: '/botAnalytics',
  TRENDING_TOPICS: '/trendingTopics',
  AUTO_QA: '/autoQA',
  SMART_TAGS: '/smartTags',
  SCHEDULE: '/scheduling',
  MY_AVAILABILITY: '/scheduling/myAvailability',
  MY_SCHEDULE: '/scheduling/mySchedule',
  AGENT_SCHEDULES: '/scheduling/agentSchedules',
  PLANNING: '/scheduling/planning',
  INTRADAY_SCHEDULING: '/scheduling/intradayDynamicScheduling',
  SCHEDULE_MANAGEMENT: '/scheduling/scheduleChangeManagement',
  WFM: '/wfm',
  TWILIO_CONFIGURATION: '/admin/twilioConfig',
  NEW_TASK_MANAGER: '/admin/taskManager',
  PHRASE_MANAGER: '/admin/phraseManager',
  ANALYTICS_CONFIG: '/admin/analyticsConfig',
  UJET_CONFIGURATION: '/admin/uJetConfig',
  LEGACY_API_ACCESS: '/admin/legacyApiAccess'
};
const PAGE_PERMISSIONS = exports.PAGE_PERMISSIONS = {
  AGENT_EXPLORER: ['ViewDesktopAnalytics'],
  AGENT_DYNAMIC_SCHEDULING: [],
  ANALYTICS: ['SystemMetrics', 'ViewAdvancedAnalytics', 'ViewAudioAnalytics', 'ViewDesktopAnalytics', 'ViewLvcsrAnalytics', 'ViewSystemAnalytics', 'ViewTextAnalytics', 'ViewTrendingTopics', 'AutoQADashboardsView', 'SmartTagView'],
  APPLICATION_MANAGEMENT: ['ViewOrg', 'ViewTenant', 'UpdateTenant', 'QMAppManagement', 'WFMAppManagement', 'CreateRoles', 'LiveMonitoring', 'AdministerTenantIT', 'AdministerAnalyticsSettings', 'SystemMetrics', 'CreateSystemLicense', 'ScheduleAppManagement'],
  QM_GLOBAL_SETTINGS: ['QMAppManagement'],
  DEVICE_ASSOCIATIONS: ['ViewDeviceConfig'],
  INCLUSION_EXCLUSION: [],
  EVALUATION_FORM_MANAGER: ['EvaluationForm'],
  ANALYTICS_MAIL_SERVER: ['UpdateTenant'],
  OUTGOING_MAIL_SERVER: ['UpdateTenant'],
  ANALYTICS_SUBSTITUTION: ['AdminLvcsrAnalytics'],
  WFM: [],
  CONTACT_QUEUE: ['ViewContactGoal'],
  PERFORMANCE_COACHING: ['AmplifAIPerformanceUser', 'AmplifAICoachUser', 'AmplifAIObserverUser', 'AmplifAISysAdminUser'],
  AGENT_PERFORMANCE: ['AmplifAIPerformanceUser'],
  TEAM_PERFORMANCE: ['AmplifAICoachUser'],
  ORGANIZATION_PERFORMANCE: ['AmplifAIObserverUser'],
  METRIC_ADMINISTRATION: ['AmplifAISysAdminUser'],
  DASHBOARD: ['AdministerDashboard', 'ViewQMDashboard', 'ViewWFMDashboard', 'DataExplorer', 'ViewBIHome'],
  ASSET_BROWSER: ['ReportAuthoring', 'ViewBIContent'],
  MESSAGING: ['AdministerMessaging', 'UpdateMessagingRequests'],
  RECORDING_CONTROLS: ['PauseResumeCommandUI', 'LoginLogoutCommandUI', 'AddMetadataCommandUI', 'TagCommandUI', 'StartStopSegmentCommandUI', 'StartStopScreenCommandUI'],
  RECORDINGS: ['SearchContacts', 'SearchScoredContacts'],
  REPORTS: ['QMReports', 'WFMReports', 'AdministerWFMReports', 'AdministerQMReports', 'SupervisorWFMReports'],
  APIDOCUMENTATION: ['ViewAPIDocumentation', 'UpdateTenant'],
  SCHEDULE: ['ViewSchedules', 'EditSchedules', 'PlanSchedules'],
  VIEW_SCHEDULES: ['ViewSchedules'],
  EDIT_SCHEDULES: ['EditSchedules'],
  PLAN_SCHEDULES: ['PlanSchedules'],
  SCHEDULE_CHANGE_MANAGEMENT: ['WFMAppManagement', 'ScheduleAppManagement'],
  TWILIO_CONFIGURATION: ['AdministerACDConfiguration'],
  BULK_CONTACT_EXPORT_MONITORING: ['BulkContactExport'],
  TRANSCRIPTION_SEARCH: ['ViewLvcsrAnalytics'],
  ANALYTICS_DASHBOARD: ['SystemMetrics', 'ViewAdvancedAnalytics', 'ViewAudioAnalytics', 'ViewDesktopAnalytics', 'ViewSystemAnalytics', 'ViewTextAnalytics'],
  UJET_CONFIGURATION: ['AdministerACDConfiguration'],
  PHRASE_MANAGER: ['AdminAudioAnalytics', 'AdminLvcsrAnalytics', 'AdminTextAnalytics', 'AdministerACDConfiguration'],
  ANALYTICS_CONFIGURATION: ['AdminAudioAnalytics', 'AdminDesktopAnalytics', 'AdminLvcsrAnalytics', 'AdminTextAnalytics'],
  TASK_MANAGER: ['AdminAudioAnalytics', 'AdminDesktopAnalytics', 'AdminLvcsrAnalytics', 'AdminTextAnalytics'],
  LEGACY_API_ACCESS: ['UpdateOrg'],
  CREATE_CDM_CONTENT: ['ReportAuthoring', 'CreateBIContent'],
  CDM_SETTINGS: ['ReportAuthoring', 'ManageBIDelivery', 'ManageBIInfospace'],
  VIEW_CDM_DATA_LIBRARY: ['ViewBIDataLibrary'],
  MANAGE_CDM_CONTENT_DELIVERY: ['ManageBIDelivery'],
  CDM_DATA_TASK_MANAGEMENT: ['AdministerTenantIT', 'AdminBITasks'],
  MANAGE_CDM_SHARING_GROUP: ['AdministerTenantIT', 'AdminBISharingGroups'],
  DATA_UDM_CONNECTOR_MANAGEMENT: ['AdministerTenantIT', 'AdminBIUDM'],
  DATA_RT_CONNECTOR_MANAGEMENT: ['AdministerTenantIT', 'AdminBIRT'],
  BI_INSIGHTS: ['BiInsightsViewContent'],
  BOT_ANALYTICS: ['BaViewExperienceAutomation', 'BaViewConvDistribution', 'BaViewConvTopics', 'BaViewImpactAnalysis', 'BaViewAggregatedMetrics', 'BaViewTranscriptSearch', 'BaViewVAAOverview', 'BaViewVAAPerformanceComparison', 'BaViewVAAResponsePerformance', 'BaViewVAAUnclassifiedMessages', 'BaViewVAAIntentPerformance', 'BaViewBotManagementReport', 'BaViewBotPerformanceReport'],
  TRENDING_TOPICS: ['ViewTrendingTopics'],
  AUTO_QA: ['AutoQADashboardsView'],
  SMART_TAGS: ['SmartTagView'],
  PERFORMANCE_MANAGEMENT: ['ViewPerformanceManagement', 'AdministerPerformanceManagementEssentials', 'AdministerPerformanceManagementEnterprise']
};
const AUTH_METHODS = exports.AUTH_METHODS = {
  FORGEROCK: 'fr',
  C1: 'c1'
};
//# sourceMappingURL=constants.js.map